import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Main from "./Main";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/js/bootstrap.esm.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "react-datepicker/dist/react-datepicker.css";
import "components/dashboard/DashboardStyle.css";
import Favicon from "react-favicon";
import logo from "./logo.png";
import { TextField } from "@mui/material";

ReactDOM.render(
  <React.StrictMode>
    <Favicon url={logo} />
    <Main />
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
